module.exports = __webpack_public_path__ + "assets/img/NATURE BROCHURE.fba4aea0.png";